<template>
  <div>
    <div class="register-top">
      <h2 class="mb-6">{{ $t('register.validation.title') }}</h2>
      <p>{{ $t('register.validation.body') }}</p>
    </div>
    <div class="register-bottom">
      <register-base-button
        :to="{ name: 'Confirmation' }"
        gradient="linear-gradient(90deg, #00D1EB 0%, #FE8B68 100%)"
      >
        {{ $t('register.validation.validate') }}
      </register-base-button>
      <br />
      <router-link :to="{ name: 'PhotoUpload' }" class="register-link mb-4">
        {{ $t('register.validation.previous') }}
      </router-link>
      <br />
      <router-link :to="{ name: 'Problem' }" class="register-link">
        {{ $t('register.validation.problem') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import RegisterBaseButton from '@/components/RegisterBaseButton'

export default {
  components: {
    RegisterBaseButton
  }
}
</script>
